import React from 'react';
import Modal from 'react-modal';
import { IModalStylesInput, setModalStyles } from '../../utils/setModalStyles';
import styled from 'styled-components';

const Wrapper = styled.div`
  font-family: ${(props) => props.theme.fonts.regular};
`;

const ModalBase: React.FC<IModalBaseProps> = ({
  children,
  isOpen,
  onCloseModal,
  modalClassName,
  modalStyles,
  loading,
}) => (
  <Modal
    ariaHideApp={false}
    isOpen={isOpen}
    shouldCloseOnOverlayClick={!loading}
    shouldCloseOnEsc={!loading}
    onRequestClose={!loading ? onCloseModal : undefined}
    style={setModalStyles(modalStyles || {})}
    className={modalClassName}
  >
    <Wrapper>{children}</Wrapper>
  </Modal>
);

export default ModalBase;

export interface IModalBaseProps {
  isOpen: boolean;
  onCloseModal: () => void;
  modalClassName?: string;
  modalStyles?: IModalStylesInput;
  loading?: boolean;
}
